<div class="p16">
  <mat-form-field class="w50" appearance="outline">
    <input matInput type="text"
           placeholder="search" i18n-placeholder
           [formControl]="searchStringCtrl"/>
  </mat-form-field>
</div>

<resto-table-grid
  restoTableGridStretchByHeight
  [restoThrottleTime]="300"
  [restoBottomMargin]="24"
  [tableId]="'table-grid-simplest-example'"
  [columnDefs]="columnDefs"
  [tableExpanded]="false"
  [tableData]="tableData"
  [dataTree]="false"
  [rowHeight]="48"
  [height]="'500px'"
  [movableColumns]="true"
  (cellClicked)="onCellClicked($event)"
  (tableInstanceChange)="tableInstanceChange($event)"
></resto-table-grid>
